import { defineComponent as o, computed as n, createElementBlock as i, openBlock as d, normalizeProps as s, guardReactiveProps as u, unref as c, renderSlot as f } from "vue";
import { useBindCx as m } from "@scalar/use-hooks/useBindCx";
import { useCardRegion as b } from "./useCardHeading.js";
const p = {}, h = /* @__PURE__ */ o({
  ...p,
  inheritAttrs: !1,
  __name: "ScalarCard",
  props: {
    label: {}
  },
  setup(e) {
    const { id: r } = b(), t = n(() => e.label ? { "aria-label": e.label } : r.value ? { "aria-labelledby": r.value } : {}), { cx: a } = m();
    return (l, _) => (d(), i("section", s(u({
      ...t.value,
      ...c(a)(
        "scalar-card bg-b-2 flex flex-col divide-y rounded-lg border *:first:rounded-t-[inherit] *:last:rounded-b-[inherit]"
      )
    })), [
      f(l.$slots, "default")
    ], 16));
  }
});
export {
  h as default
};
